import WarningIcon from "./icons/WarningIcon";
import "./WarningNotice.scss";

interface Props {
  text: React.ReactNode;
}

export default function WarningNotice({text}: Props) {
  return <div className={"warning-notice"}>
    <div>
      <WarningIcon />
      <span>{text}</span>
    </div>
  </div>
}
